import { Injectable } from '@angular/core';
import { Client } from '@stomp/stompjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private client!: Client;

  constructor() {
    this.init();
  }

  private init() {
    this.client = new Client({
      brokerURL: `${environment.wsUrl}/ws`,
      reconnectDelay: 5000,

      debug: (message: string) => {},
    });

    this.client.onConnect = (frame) => {
    };

    this.client.onDisconnect = () => {};

    this.client.onStompError = (frame) => {};

    this.client.onWebSocketError = (error) => {};

    this.client.onWebSocketClose = (event) => {};
  }

  connect(): Client {
    if (this.client.active) {
      return this.client;
    }

    if (!this.client) {
      this.init();
    }

    this.client.activate();
    return this.client;
  }

  disconnect(): void {
    this.client.deactivate();
  }
}
